export const Divisions = {
  UK: { value: "uk", label: "United Kingdom" },
  KY: { value: "ky", label: "Cayman Islands" },
} as const;
